import { render } from "./selectPpStatus.vue?vue&type=template&id=ef6c6136"
import script from "./selectPpStatus.vue?vue&type=script&lang=js"
export * from "./selectPpStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__